import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = () => {
    const { setAuthData, authData } = useAuth(); // Get authData to check user role
    const navigate = useNavigate();
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const handleLogout = () => {
        setAuthData(null);
        localStorage.removeItem('authData');
        navigate('/');
    };

    // Check user roles
    const isGod = authData?.profiles?.includes('GOD');
    const isAdmin = authData?.profiles?.includes('ADMIN');
    const isUser = authData?.profiles?.includes('USER');
    

    return (
        <div
            id="sidebar"
            class={`sidebar bg-gray-800 text-white ${isCollapsed ? 'w-20' : 'w-64'
                } flex-shrink-0 flex flex-col transition-all duration-300`}
        >
            <div class="p-4 flex items-center justify-between border-b border-gray-700">
                <div
                    class={`flex items-center space-x-2 cursor-pointer ${isCollapsed ? 'hidden' : ''
                        }`}
                    onClick={() => navigate('/dashboard/home')}
                >
                    <img
                        src="/logo_nb.png"
                        alt="StockEasy Logo"
                        class="h-10"
                    />
                    <span class="text-xl font-bold sidebar-text">StockEasy</span>
                </div>
                <button
                    id="toggleSidebar"
                    class="text-gray-400 hover:text-white"
                    onClick={toggleSidebar}
                >
                    <i class={`fas ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
                </button>
            </div>
            <div class="flex-grow overflow-y-auto">
                <nav class="p-4">
                    <div class="mb-8">
                        <p
                            class={`text-gray-400 uppercase text-xs font-semibold mb-3 sidebar-text ${isCollapsed ? 'hidden' : ''
                                }`}
                        >
                            Main
                        </p>
                        <ul>
                            {/* Home - Available for all roles */}
                            <li>
                                <NavLink
                                    to="/dashboard/home"
                                    className={({ isActive }) =>
                                        `dashboard-link flex items-center py-2 px-3 rounded-lg ${isActive
                                            ? 'text-white bg-blue-600'
                                            : 'text-gray-300 hover:text-white hover:bg-gray-700'
                                        }`
                                    }
                                >
                                    <i class="fas fa-home sidebar-icon mr-3"></i>
                                    <span class={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>
                                        Home
                                    </span>
                                </NavLink>
                            </li>

                            {/* Pre Load File - Only for USER and ADMIN */}
                            {(isUser || isAdmin) && (
                                <li>
                                    <NavLink
                                        to="/dashboard/preload"
                                        className={({ isActive }) =>
                                            `dashboard-link flex items-center py-2 px-3 rounded-lg ${isActive
                                                ? 'text-white bg-blue-600'
                                                : 'text-gray-300 hover:text-white hover:bg-gray-700'
                                            }`
                                        }
                                    >
                                        <i class="fas fa-upload sidebar-icon mr-3"></i>
                                        <span class={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>
                                            Pre Load File
                                        </span>
                                    </NavLink>
                                </li>
                            )}

                            {/* Scanning Session - Only for USER and ADMIN */}
                            {(isUser || isAdmin) && (
                                <li>
                                    <NavLink
                                        to="/dashboard/scanning-session"
                                        className={({ isActive }) =>
                                            `dashboard-link flex items-center py-2 px-3 rounded-lg ${isActive
                                                ? 'text-white bg-blue-600'
                                                : 'text-gray-300 hover:text-white hover:bg-gray-700'
                                            }`
                                        }
                                    >
                                        <i class="fas fa-barcode sidebar-icon mr-3"></i>
                                        <span class={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>
                                            Scanning Session
                                        </span>
                                    </NavLink>
                                </li>
                            )}

                            {/* Manage Users - Only for GOD and ADMIN */}
                            {(isGod || isAdmin) && (
                                <li>
                                    <NavLink
                                        to="/dashboard/users"
                                        className={({ isActive }) =>
                                            `dashboard-link flex items-center py-2 px-3 rounded-lg ${isActive
                                                ? 'text-white bg-blue-600'
                                                : 'text-gray-300 hover:text-white hover:bg-gray-700'
                                            }`
                                        }
                                    >
                                        <i class="fas fa-users sidebar-icon mr-3"></i>
                                        <span class={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>
                                            Manage Users
                                        </span>
                                    </NavLink>
                                </li>
                            )}

                            {/* Manage Licenses - Only for GOD */}
                            {isGod && (
                                <li>
                                    <NavLink
                                        to="/dashboard/licenses"
                                        className={({ isActive }) =>
                                            `dashboard-link flex items-center py-2 px-3 rounded-lg ${isActive
                                                ? 'text-white bg-blue-600'
                                                : 'text-gray-300 hover:text-white hover:bg-gray-700'
                                            }`
                                        }
                                    >
                                        <i class="fas fa-list sidebar-icon mr-3"></i>
                                        <span class={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>
                                            Manage Licenses
                                        </span>
                                    </NavLink>
                                </li>
                            )}
                        </ul>
                    </div>
                </nav>
            </div>
            <div class="p-4 border-t border-gray-700">
                <button
                    id="logoutBtn"
                    class="flex items-center w-full py-2 px-3 rounded-lg text-gray-300 hover:text-white hover:bg-gray-700"
                    onClick={handleLogout}
                >
                    <i class="fas fa-sign-out-alt sidebar-icon mr-3"></i>
                    <span class={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>Logout</span>
                </button>
            </div>
        </div>
    );
};

export default Sidebar;